const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * OPTIMIZED: Fetch paginated maps for gallery view (lightweight data)
 * Returns only essential fields for fast initial load
 */
export const fetchMapsGallery = async ({ page = 1, limit = 20, search, author, region } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  
  if (search) params.append('search', search);
  if (author && author !== 'all') params.append('author', author);
  if (region && region !== 'all') params.append('region', region);
  
  const url = `${API_URL}/api/maps/gallery?${params.toString()}`;
  
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json(); // Returns { maps, total, page, limit, hasMore }
};

/**
 * Fetch ALL maps with lightweight data (for Explorer map markers)
 * Use sparingly - prefer fetchMapsGallery with pagination
 */
export const fetchMapsLightweight = async () => {
  const response = await fetch(`${API_URL}/api/maps/all-lightweight`);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

/**
 * DEPRECATED: Fetch all maps with full data
 * Use fetchMapsGallery for better performance
 */
export const fetchMaps = async (filters = {}) => {
  const { search, author, region } = filters;
  const params = new URLSearchParams();
  
  if (search) params.append('search', search);
  if (author && author !== 'all') params.append('author', author);
  if (region && region !== 'all') params.append('region', region);
  
  const queryString = params.toString();
  const url = `${API_URL}/api/maps${queryString ? `?${queryString}` : ''}`;
  
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

/**
 * Fetch full map details by ID
 * Call this only when user clicks to view a specific map
 */
export const fetchMapById = async (id) => {
  const response = await fetch(`${API_URL}/api/maps/${id}`);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchFilters = async () => {
  const response = await fetch(`${API_URL}/api/maps/filters`);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};
